var _path, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 51,
    viewBox: "0 0 53 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.785 2.85836C25.5618 1.56367 27.4382 1.56367 28.215 2.85836L47.6323 35.221C48.4321 36.5541 47.4719 38.25 45.9173 38.25H7.08269C5.5281 38.25 4.56787 36.5541 5.36769 35.221L24.785 2.85836Z",
    fill: "#FCE809"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 11,
    width: 3,
    height: 16,
    rx: 1.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 31.5,
    r: 2.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningYellow);
export default __webpack_public_path__ + "static/media/Icon_Warning_Yellow.65af4dd068226b496464b7c903818f3d.svg";
export { ForwardRef as ReactComponent };